import { apolloClient } from "@/plugins/vue-apollo.js";

const createUnit = async ( variables) => {
    let responseFromApi = await apolloClient.mutate({
        mutation: require("@/landlord/api/mutations/create_unit.graphql"),
        variables:variables ,
    }).catch((error) => {
        throw error;
    })
    return responseFromApi;

};

export { createUnit };
